export default {
  path: '/report',
  name: 'report',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '报表',
    keepAlive: false
  },
  children: [
    {
      path: 'watchDataReport',
      name: 'watchDataReport',
      component: () => import('../../views/Report/Watch/DataReport/WatchCardDataReport/WatchCardDataReportIndex.vue'),
      meta: {title: '腕表卡数据报表', keepAlive: false}
    },
    {
      path: 'bigFlowCardDataReport',
      name: 'bigFlowCardDataReport',
      component: () => import('../../views/Report/Watch/DataReport/BigFlowCardDataReport/BigFlowCardDataReportIndex'),
      meta: { title: '大流量卡数据报表', keepAlive: false }
    },
    {
      path: 'dataReportDetail',
      name: 'dataReportDetail',
      // hidden: true,
      component: () => import('../../views/Report/Watch/DataReport/ReportDetail/SeeDetails'),
      meta: { title: '数据报表详情', keepAlive: false }
    },
    {
      path: 'numCardDataList',
      name: 'numCardDataList',
      component: () => import('../../views/Report/Watch/DataReport/ReportDetail/NumCardDataList'),
      meta: { title: '号卡统计数据列表', keepAlive: false }
    },
    {
      path: 'commissionDataList',
      name: 'commissionDataList',
      component: () => import('../../views/Report/Watch/DataReport/ReportDetail/CommissionDataList'),
      meta: { title: '佣金统计数据列表', keepAlive: false }
    },
  
  ]
}